import type React from "react";

import styled, { useTheme } from "styled-components";

import { useWindowSize } from "utils/hooks";

interface Props {
  phone: string | undefined;
  country: string;
  className?: string;
}

export const PhoneNumber: React.FC<Props> = ({ phone, country, className }) => {
  const { width } = useWindowSize();
  const theme = useTheme();

  if (!phone) {
    return <></>;
  }

  let formattedPhone = phone;
  switch (country) {
    case "Sweden":
      formattedPhone = `${phone.slice(0, 3)} ${phone.slice(3, 5)} ${phone.slice(5, 8)} ${phone.slice(
        8,
        10
      )} ${phone.slice(10)}`;
      break;
    case "USA":
      formattedPhone = `${phone.slice(0, 2)} (${phone.slice(2, 5)}) ${phone.slice(5, 8)} ${phone.slice(8)}`;
      break;
    default:
      break;
  }

  return width <= parseInt(theme.breakpointMobile, 10) ? (
    <TextArea className={className} href={`tel:${phone}`}>
      {formattedPhone}
    </TextArea>
  ) : (
    <span className={className}>{formattedPhone}</span>
  );
};

const TextArea = styled.a`
  color: ${props => props.theme.colors.redesign.b100};
  font-weight: 500;
  text-decoration: none;
`;
